export enum IncomingInvoiceTabsEnum {
  INVOICE_FILE = 'invoice-file',
  BILLING_INFORMATION = 'billing-information',
  AMOUNT_DUE = 'amount-due',
  POSITIONS = 'positions',
  PAYMENTS = 'payments',
  DOCUMENTS = 'documents',
}
